import {
  ListItemText,
  MenuItem,
  Popover,
  Stack,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { PopoverProps } from 'src/components/PopoverTrigger';
import { useLocales } from 'src/locales';

export const OrderCollaborateNavPopOver = ({
  target,
  handleClose,
  handleOrderSelect,
  orderBy,
}: PopoverProps<{
  handleOrderSelect: (orderType: 'asc' | 'desc') => void;
  orderBy: 'asc' | 'desc';
}>) => {
  const { translate } = useLocales();
  const theme = useTheme();
  const open = Boolean(target);
  return (
    <Popover
      open={open}
      anchorEl={target}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{
        paper: {
          sx: { p: 0.5 },
        },
      }}
    >
      <Stack
        px={1}
        py={0.5}
        mb={1}
        borderBottom={`1px solid ${theme.palette.divider}`}
      >
        <Typography variant="button" color="text.disabled">
          {translate('header.nav.drawer_sort.order')}
        </Typography>
      </Stack>
      <MenuItem
        onClick={() => handleOrderSelect('asc')}
        selected={orderBy === 'asc'}
      >
        <ListItemText primary={translate('header.nav.drawer_sort.ascending')} />
      </MenuItem>
      <MenuItem
        onClick={() => handleOrderSelect('desc')}
        selected={orderBy === 'desc'}
      >
        <ListItemText
          primary={translate('header.nav.drawer_sort.descending')}
        />
      </MenuItem>
    </Popover>
  );
};
